import React from 'react'
import PropTypes from 'prop-types'

import ListingDetail from 'syft-acp-core/entities/ListingDetail/ListingDetail'
import PageTitle from 'syft-acp-core/components/PageTitle'

const ListingView = ({ match: { params } }) => {
  const title = [`Listing ${params.id}`]
  if (params.jobID) title.push(`job ${params.jobID}`)
  if (params.shiftID) title.push(`shift ${params.shiftID}`)

  return (
    <PageTitle title={title}>
      <ListingDetail
        id={Number(params.id)}
        jobID={params.jobID ? Number(params.jobID) : 0}
        shiftID={params.shiftID ? Number(params.shiftID) : 0}
      />
    </PageTitle>
  )
}

ListingView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

export default ListingView
